import { useParams, useRouter } from '@tanstack/react-router';

import { NavigationHeader } from '../../components/NavigationHeader/NavigationHeader';
import { Layout } from '../../components/Layout/Layout';
import { useWorkflow } from '../../workflow/hooks';
import { Callout } from '../../components/Callout/Callout';
import { Flex } from '@repo/ui/Flex';
import { getItemDescription } from '../../utils/item';
import s from './IneligibleDetails.module.css';
import { Text } from '../../components/Language/Language';
import { Page } from '../../components/Page/Page';

export const IneligibleDetails = () => {
  const router = useRouter();
  const { itemId } = useParams({
    from: '/$retailer/ineligible-details/$itemId',
  });
  const { order } = useWorkflow();
  const item = order?.items.find((item) => item.id === itemId);

  const handleBack = () => router.history.back();

  if (!item) {
    return <div>Something went wrong</div>;
  }

  return (
    <Page>
      <NavigationHeader
        title={{
          langKey: 'Global.ineligibleDetails.page.header',
        }}
        onBack={handleBack}
        onClose={handleBack}
      />

      <Layout>
        <Flex padding={['px-16', 'md:px-24']} gap="g-16" direction="column">
          {item.ineligibleReasons && (
            <Callout variant="info">
              {item.ineligibleReasons.map((code) => (
                <Text
                  key={code}
                  langKey={`Global.ineligibleDetails.ineligibleReason.${code}`}
                  fallback={code}
                />
              ))}
            </Callout>
          )}
          <div className={s.item}>
            <div className={s.itemImage}>
              <div className={s.imageWrap}>
                <img
                  alt={item.name ?? ''}
                  className={s.image}
                  src={item.image?.url ?? undefined}
                />
              </div>
            </div>
            <div className={s.itemDetails}>
              <Flex
                direction="column"
                gap={['g-4', 'md:g-8']}
                padding={['md:py-12']}
              >
                <h2 className={s.itemName}>{item.name}</h2>
                <p className={s.itemDescription}>
                  {getItemDescription({
                    item,
                  })}
                </p>
              </Flex>
            </div>
          </div>
        </Flex>
      </Layout>
    </Page>
  );
};
